import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {
    Hero,
    HeroSlider,
    CategoryQuickLinks,
    ImageLink,
    HeadlineSubtitle,
    ImageRowOfTwo,
    ShopTheLook,
    PlpStoryComponent,
    FullImageX4,
    FullImageX4Desktop,
    StoryTelling,
    TextTilesX4,
    CategoryRowTall,
    FullWidthImageHeadlineLink,
    SocialGallery,
    Recommendations,
    RecommendationsEinstein,
    Spacer,
    ShopTheLookSlider,
    ShopTheLookSliderItem,
    FAQ,
    FAQItem,
    CategoryProductCarousels,
    ScrollingPromoBar,
    ScrollingPromoBarItem,
    CondensedCategorySlider,
    HeroPromotionPercentOff,
    HeroPromotionBuyXForY,
    HeroPromotionUpToPercentOff,
    HeroCustomTextBanner,
    HeroXXValueBadge,
    HeroTermsAndConditions,
    PromoGridTwoColumns,
    PromoGridThreeColumns,
    PromoGridFourColumns,
    PromoGridItem,
    TextOnly,
    EmailSignUp,
    CountdownTimerBanner,
    TextOnlyQuickLinks,
    TextLink,
    EspProducts,
    Testimonials,
    TestimonialsItem,
    PromoQuickCategory,
    PromoQuickCategoryLink,
    List,
    TextMarkup
} from './assets'
import {
    PD_HERO,
    PD_HERO_SLIDER,
    PD_BANNER,
    PD_CATEGORY_QUICK_LINKS,
    PD_IMAGE_LINKS,
    PD_FULL_IMAGE_X4,
    PD_FULL_IMAGE_X4_DESKTOP,
    PD_HEADLINE_SUBTITLE,
    PD_IMAGE_ROW_OF_TWO,
    PD_PLP_STORY_COMPONENT,
    PD_STORY_TELLING,
    PD_TEXT_TILES_X4,
    PD_CATEGORY_ROW_TALL,
    PD_FULL_WIDTH_IMAGE_HEADLINE_LINK,
    PD_SOCIAL_GALLERY,
    PD_RECOMMENDATIONS,
    PD_RECOMMENDATIONS_EINSTEIN,
    PD_SHOP_THE_LOOK,
    PD_SPACER,
    PD_SHOP_THE_LOOK_GALLERY,
    PD_SHOP_THE_LOOK_GALLERY_ITEM,
    PD_SHOP_THE_LOOK_SLIDER,
    PD_SHOP_THE_LOOK_SLIDER_ITEM,
    PD_FAQ,
    PD_FAQ_ITEM,
    PD_PDP_MONETATE_CAROUSEL,
    PD_CATEGORY_PRODUCT_CAROUSELS,
    PD_SCROLLING_PROMO_BAR,
    PD_SCROLLING_PROMO_BAR_ITEM,
    PD_CONDENSED_CATEGORY_SLIDER,
    PD_HERO_PROMOTION_PERCENT_OFF,
    PD_HERO_PROMOTION_BUY_X_FOR_Y,
    PD_HERO_PROMOTION_UP_TO_PERCENT_OFF,
    PD_HERO_CUSTOM_TEXT_BANNER,
    PD_HERO_MULTIPLE_CTA,
    PD_HERO_XX_VALUE_BADGE,
    PD_HERO_TERMS_AND_CONDITIONS,
    PD_PROMO_GRID_TWO_COLUMNS,
    PD_PROMO_GRID_THREE_COLUMNS,
    PD_PROMO_GRID_FOUR_COLUMNS,
    PD_PROMO_GRID_ITEM,
    PD_TEXT_ONLY,
    PD_EMAIL_SIGNUP,
    PD_COUNTDOWN_TIMER_BANNER,
    PD_TEXT_ONLY_QUICK_LINKS,
    PD_TEXT_LINKS,
    PD_LINK_GRID,
    PD_PROMO_PAIRABLE_STYLES,
    PD_ESP_PRODUCTS,
    PD_TESTIMONIALS,
    PD_TESTIMONIALS_ITEM,
    PD_PROMO_QUICK_CATEGORY,
    PD_PROMO_QUICK_CATEGORY_LINK,
    PD_LIST,
    PD_TEXT_MARKUP
} from '../../constants'
import {PdpMonetateCarousel} from './assets/pdp-monetate-carousel'
import PromoPairableStyles from './assets/promo-pairable-styles'
import HeroMultipleCTAa from './assets/hero-multiple-cta'
import ShopTheLookGallery from './assets/shop-the-look-gallery'
import ShopTheLookGalleryItem from './assets/shop-the-look-gallery-item'
import LinkGrid from './assets/link-grid'

export const COMPONENTS = {
    [PD_HERO]: Hero,
    [PD_HERO_SLIDER]: HeroSlider,
    [PD_BANNER]: Hero,
    [PD_CATEGORY_QUICK_LINKS]: CategoryQuickLinks,
    [PD_IMAGE_LINKS]: ImageLink,
    [PD_FULL_IMAGE_X4]: FullImageX4,
    [PD_FULL_IMAGE_X4_DESKTOP]: FullImageX4Desktop,
    [PD_HEADLINE_SUBTITLE]: HeadlineSubtitle,
    [PD_IMAGE_ROW_OF_TWO]: ImageRowOfTwo,
    [PD_SHOP_THE_LOOK]: ShopTheLook,
    [PD_PLP_STORY_COMPONENT]: PlpStoryComponent,
    [PD_STORY_TELLING]: StoryTelling,
    [PD_TEXT_TILES_X4]: TextTilesX4,
    [PD_CATEGORY_ROW_TALL]: CategoryRowTall,
    [PD_FULL_WIDTH_IMAGE_HEADLINE_LINK]: FullWidthImageHeadlineLink,
    [PD_PROMO_PAIRABLE_STYLES]: PromoPairableStyles,
    [PD_SOCIAL_GALLERY]: SocialGallery,
    [PD_RECOMMENDATIONS]: Recommendations,
    [PD_RECOMMENDATIONS_EINSTEIN]: RecommendationsEinstein,
    [PD_SPACER]: Spacer,
    [PD_SHOP_THE_LOOK_GALLERY]: ShopTheLookGallery,
    [PD_SHOP_THE_LOOK_GALLERY_ITEM]: ShopTheLookGalleryItem,
    [PD_SHOP_THE_LOOK_SLIDER]: ShopTheLookSlider,
    [PD_SHOP_THE_LOOK_SLIDER_ITEM]: ShopTheLookSliderItem,
    [PD_FAQ]: FAQ,
    [PD_FAQ_ITEM]: FAQItem,
    [PD_PDP_MONETATE_CAROUSEL]: PdpMonetateCarousel,
    [PD_CATEGORY_PRODUCT_CAROUSELS]: CategoryProductCarousels,
    [PD_SCROLLING_PROMO_BAR]: ScrollingPromoBar,
    [PD_SCROLLING_PROMO_BAR_ITEM]: ScrollingPromoBarItem,
    [PD_CONDENSED_CATEGORY_SLIDER]: CondensedCategorySlider,
    [PD_HERO_PROMOTION_PERCENT_OFF]: HeroPromotionPercentOff,
    [PD_HERO_PROMOTION_BUY_X_FOR_Y]: HeroPromotionBuyXForY,
    [PD_HERO_PROMOTION_UP_TO_PERCENT_OFF]: HeroPromotionUpToPercentOff,
    [PD_HERO_CUSTOM_TEXT_BANNER]: HeroCustomTextBanner,
    [PD_HERO_XX_VALUE_BADGE]: HeroXXValueBadge,
    [PD_HERO_MULTIPLE_CTA]: HeroMultipleCTAa,
    [PD_HERO_TERMS_AND_CONDITIONS]: HeroTermsAndConditions,
    [PD_PROMO_GRID_TWO_COLUMNS]: PromoGridTwoColumns,
    [PD_PROMO_GRID_THREE_COLUMNS]: PromoGridThreeColumns,
    [PD_PROMO_GRID_FOUR_COLUMNS]: PromoGridFourColumns,
    [PD_PROMO_GRID_ITEM]: PromoGridItem,
    [PD_TEXT_ONLY]: TextOnly,
    [PD_EMAIL_SIGNUP]: EmailSignUp,
    [PD_COUNTDOWN_TIMER_BANNER]: CountdownTimerBanner,
    [PD_TEXT_ONLY_QUICK_LINKS]: TextOnlyQuickLinks,
    [PD_TEXT_LINKS]: TextLink,
    [PD_LINK_GRID]: LinkGrid,
    [PD_ESP_PRODUCTS]: EspProducts,
    [PD_TESTIMONIALS]: Testimonials,
    [PD_TESTIMONIALS_ITEM]: TestimonialsItem,
    [PD_PROMO_QUICK_CATEGORY]: PromoQuickCategory,
    [PD_PROMO_QUICK_CATEGORY_LINK]: PromoQuickCategoryLink,
    [PD_LIST]: List,
    [PD_TEXT_MARKUP]: TextMarkup
}

const PDComponent = ({
    page,
    component,
    product,
    dataLayerLoaded = true,
    parent = false,
    ...rest
}) => {
    const renderComponent = (component) => {
        const Component = COMPONENTS[component.typeId]
        return Component ? (
            parent ? (
                /** NOTE: NEVER assign these IDs to the child components!! **/
                <Box
                    key={component.id}
                    data-name={component.name}
                    data-typeid={component.typeId}
                    id={component.data?.customComponentId || component.id?.slice(0, 5)}
                >
                    <Component
                        key={component.id}
                        product={product}
                        pageData={page?.data}
                        dataLayerLoaded={dataLayerLoaded}
                        typeId={component.typeId}
                        name={component.name}
                        regions={component.regions}
                        {...component.data}
                        {...rest}
                    />
                </Box>
            ) : (
                <Component
                    key={component.id}
                    product={product}
                    pageData={page?.data}
                    dataLayerLoaded={dataLayerLoaded}
                    typeId={component.typeId}
                    name={component.name}
                    regions={component.regions}
                    {...component.data}
                    {...rest}
                />
            )
        ) : null
    }

    if (component) {
        return renderComponent(component)
    }

    if (page?.regions) {
        return page?.regions?.map((region) =>
            region?.components?.map((component) => renderComponent(component))
        )
    }

    return page?.components?.map((component) => renderComponent(component))
}

PDComponent.propTypes = {
    page: PropTypes.object,
    product: PropTypes.any,
    parent: PropTypes.bool,
    component: PropTypes.object
}

export default PDComponent
